export const colors = {
  transparent: 'transparent',
  current: 'currentColor',
  black: '#000000',
  white: '#ffffff',

  purple: {
    100: '#DCDBEB',
    200: '#C7C5E5',
    400: '#5049A4',
    600: '#5049A4',
  },
  red: {
    100: '#F5DADD',
    200: '#F5C6CC',
    400: '#ED4156',
    600: '#D20000',
  },
  orange: {
    100: '#FBEAD7',
    200: '#F5D7B5',
    400: '#FF8F28',
    600: '#EE6400',
  },
  blue: {
    100: '#E4F7FE',
    200: '#C7EDF9',
    400: '#66DAFF',
    600: '#0769C3',
  },
  green: {
    100: '#EFFBE8',
    200: '#D4F1C3',
    400: '#9EEB82',
    600: '#0C651A',
  },
  teal: {
    100: '#D5FAF2',
    200: '#B1ECDF',
    400: '#00E9BF',
    600: '#058787',
  },
  sand: {
    100: '#FAF7F3',
  },
  grey: {
    400: '#575757',
    600: '#353331',
  },
};

export type ThemeColor = 'blue' | 'teal' | 'orange' | 'red' | 'purple' | 'green' | 'default';

export const themeColors = {
  blue: {
    100: {
      color: 'text-blue-100',
      bg: 'bg-blue-100',
      border: 'border-blue-100',
      fill: 'fill-blue-100',
      hex: colors.blue[100],
    },
    200: {
      color: 'text-blue-200',
      bg: 'bg-blue-200',
      border: 'border-blue-200',
      fill: 'fill-blue-200',
      hex: colors.blue[200],
    },
    400: {
      color: 'text-blue-400',
      bg: 'bg-blue-400',
      border: 'border-blue-400',
      fill: 'fill-blue-400',
      hex: colors.blue[400],
    },
    600: {
      color: 'text-blue-600',
      bg: 'bg-blue-600',
      border: 'border-blue-600',
      fill: 'fill-blue-600',
      hex: colors.blue[600],
    },
  },
  teal: {
    100: {
      color: 'text-teal-100',
      bg: 'bg-teal-100',
      border: 'border-teal-100',
      fill: 'fill-teal-100',
      hex: colors.teal[100],
    },
    200: {
      color: 'text-teal-200',
      bg: 'bg-teal-200',
      border: 'border-teal-200',
      fill: 'fill-teal-200',
      hex: colors.teal[200],
    },
    400: {
      color: 'text-teal-400',
      bg: 'bg-teal-400',
      border: 'border-teal-400',
      fill: 'fill-teal-400',
      hex: colors.teal[400],
    },
    600: {
      color: 'text-teal-600',
      bg: 'bg-teal-600',
      border: 'border-teal-600',
      fill: 'fill-teal-600',
      hex: colors.teal[600],
    },
  },
  orange: {
    100: {
      color: 'text-orange-100',
      bg: 'bg-orange-100',
      border: 'border-orange-100',
      fill: 'fill-orange-100',
      hex: colors.orange[100],
    },
    200: {
      color: 'text-orange-200',
      bg: 'bg-orange-200',
      border: 'border-orange-200',
      fill: 'fill-orange-200',
      hex: colors.orange[200],
    },
    400: {
      color: 'text-orange-400',
      bg: 'bg-orange-400',
      border: 'border-orange-400',
      fill: 'fill-orange-400',
      hex: colors.orange[400],
    },
    600: {
      color: 'text-orange-600',
      bg: 'bg-orange-600',
      border: 'border-orange-600',
      fill: 'fill-orange-600',
      hex: colors.orange[600],
    },
  },
  red: {
    100: {
      color: 'text-red-100',
      bg: 'bg-red-100',
      border: 'border-red-100',
      fill: 'fill-red-100',
      hex: colors.red[100],
    },
    200: {
      color: 'text-red-200',
      bg: 'bg-red-200',
      border: 'border-red-200',
      fill: 'fill-red-200',
      hex: colors.red[200],
    },
    400: {
      color: 'text-red-400',
      bg: 'bg-red-400',
      border: 'border-red-400',
      fill: 'fill-red-400',
      hex: colors.red[400],
    },
    600: {
      color: 'text-red-600',
      bg: 'bg-red-600',
      border: 'border-red-600',
      fill: 'fill-red-600',
      hex: colors.red[600],
    },
  },
  purple: {
    100: {
      color: 'text-purple-100',
      bg: 'bg-purple-100',
      border: 'border-purple-100',
      fill: 'fill-purple-100',
      hex: colors.purple[100],
    },
    200: {
      color: 'text-purple-200',
      bg: 'bg-purple-200',
      border: 'border-purple-200',
      fill: 'fill-purple-200',
      hex: colors.purple[200],
    },
    400: {
      color: 'text-purple-400',
      bg: 'bg-purple-400',
      border: 'border-purple-400',
      fill: 'fill-purple-400',
      hex: colors.purple[400],
    },
    600: {
      color: 'text-purple-600',
      bg: 'bg-purple-600',
      border: 'border-purple-600',
      fill: 'fill-purple-600',
      hex: colors.purple[600],
    },
  },
  green: {
    100: {
      color: 'text-green-100',
      bg: 'bg-green-100',
      border: 'border-green-100',
      fill: 'fill-green-100',
      hex: colors.green[100],
    },
    200: {
      color: 'text-green-200',
      bg: 'bg-green-200',
      border: 'border-green-200',
      fill: 'fill-green-200',
      hex: colors.green[200],
    },
    400: {
      color: 'text-green-400',
      bg: 'bg-green-400',
      border: 'border-green-400',
      fill: 'fill-green-400',
      hex: colors.green[400],
    },
    600: {
      color: 'text-green-600',
      bg: 'bg-green-600',
      border: 'border-green-600',
      fill: 'fill-green-600',
      hex: colors.green[600],
    },
  },
  default: {} as any,
};

// Set default color to purple
themeColors.default = themeColors.purple;
